import * as actionTypes from '@/store/action-types'
import * as mutationTypes from '@/store/mutation-types'
import { SCHEDULING_GET_PARAMETERS } from '@/store/getter-types'
import { SchedulingState } from '@/types/application-state'

const state: SchedulingState = {
  data: undefined
}

const getters = {
  [SCHEDULING_GET_PARAMETERS] (state: SchedulingState): SchedulingState {
    return state
  }
}

const mutations = {
  [mutationTypes.SCHEDULING_SET_PARAMETERS_MUTATION] (state: SchedulingState, payload: any): void {
    state.data = payload
  }
}

const actions = {
  [actionTypes.SCHEDULING_SET_PARAMETERS] ({ commit }: { commit: Function }, payload: any): void {
    commit(mutationTypes.SCHEDULING_SET_PARAMETERS_MUTATION, payload)
  }
}

const schedulingModule = {
  state,
  getters,
  mutations,
  actions
}

export default schedulingModule

